<script>
import { Back } from "@element-plus/icons-vue";

export default {
  components: {
    Back,
  },
};
</script>

<template>
  <div class="not-page">
    <div class="not-page__top">
      <div class="not-page__top-left">
        <el-button link @click="$router.push({ name: 'charts' })">
          <template #icon>
            <Back />
          </template>
          Back</el-button
        >
        <el-divider class="not-page__top-divider" direction="vertical" />
        <div class="not-page__title">404</div>
      </div>
    </div>
    <div class="not-page__main">
      <div class="not-page__content">
        <div class="not-page__image-wrapper">
          <img src="@/shared/assets/images/404.svg" alt="404" />
          <img
            src="@/shared/assets/images/bimi-404.png"
            alt="bimi"
            class="not-page__image-bimi"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.not-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 24px;
    height: 56px;
    flex-shrink: 0;
    margin-bottom: 16px;
  }
  &__top-left {
    display: flex;
    align-items: center;
  }
  &__top-divider {
    margin: 0 16px;
  }
  &__title {
    font-size: 18px;
    font-weight: 800;
    line-height: 26px;
  }
  &__main {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
    padding-right: 24px;
  }
  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    height: 100%;
    width: 100%;
    border-radius: var(--Radius-border-radius-base, 4px);
    background: var(--Color-Background-bg-color, #fff);
  }
  &__image-wrapper {
    position: relative;
    width: 306px;
    height: 456px;
  }
  &__image-bimi {
    position: absolute;
    left: 0;
    right: 0;
  }
}
</style>
